<h2 mat-dialog-title class="sk-dialog-title"><mat-icon>add_link</mat-icon> Lager verknüpfen</h2>

<mat-dialog-content class="dialog-content">
  <p class="sk-muted intro">
    Verknüpfte Lager sehen Bauleiter und Vorarbeiter dieses Stammkunden automatisch mit.
  </p>

  <div class="sk-loading" *ngIf="loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div class="sk-empty" *ngIf="!loading && available.length === 0">
    <div class="sk-empty-icon"><mat-icon>inventory_2</mat-icon></div>
    <p>Kein weiteres Lager verfügbar.<br>
      <span class="sk-muted">Es können nur Lager verknüpft werden, auf die du selbst Zugriff hast.</span>
    </p>
  </div>

  <div class="warehouse-option" *ngFor="let w of available"
       [class.selected]="selectedId === w.id" (click)="select(w)">
    <mat-icon>{{selectedId === w.id ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
    <mat-icon class="wh-icon">warehouse</mat-icon>
    <strong>{{w.name}}</strong>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()"
          [disabled]="saving || selectedId == null">
    <mat-icon>link</mat-icon> Verknüpfen
  </button>
</mat-dialog-actions>
